"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProcessor = void 0;
var PaymentProcessor;
(function (PaymentProcessor) {
    PaymentProcessor["ADYEN"] = "ADYEN";
    PaymentProcessor["CHASE"] = "CHASE";
    PaymentProcessor["FIRSTDATA"] = "FIRSTDATA";
    PaymentProcessor["FIRSTPAY"] = "FIRSTPAY";
    PaymentProcessor["VRPAYMENT"] = "VRPAYMENT";
    PaymentProcessor["ORBITAL"] = "ORBITAL";
    PaymentProcessor["PAYMARK"] = "PAYMARK";
    PaymentProcessor["WORLDPAY"] = "WORLDPAY";
    PaymentProcessor["PAYCOMET"] = "PAYCOMET";
})(PaymentProcessor = exports.PaymentProcessor || (exports.PaymentProcessor = {}));
//# sourceMappingURL=payment-vendor.js.map